/* eslint-disable jsx-a11y/img-redundant-alt */
import {
  FormControlLabel,
  Skeleton,
  Switch,
  Typography,
  styled,
} from "@mui/material";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { useNavigate } from "react-router";
// import GraphicEqRoundedIcon from "@mui/icons-material/GraphicEqRounded";

import voice from "../../../media/svg/voice.svg";
import CustomAvatar from "../CustomAvatar";
// import Replayed from "../Replayed";
import {
  getPlayerState,
  setVoiceOnly,
} from "../../../redux/features/playerSlice";
import RightLeftChecker from "./../../../utils/RightLeftChecker";

const HeaderMediaPlayer = (props) => {
  const { voiceOnly } = useSelector(getPlayerState);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const VoiceSwitch = styled(Switch)(({ theme }) => ({
    "&.MuiSwitch-root": {
      width: 54,
      height: 34,
      padding: 0,
      borderRadius: 16,
      border: `2px solid ${theme.palette.black.main}`,
      overflow: "unset",
      "& .MuiSwitch-track": {
        borderRadius: 16,
        opacity: `${voiceOnly ? 0.8 : 1}!IMPORTANT`,
        backgroundColor: `${
          voiceOnly ? theme.palette.primary.main : theme.palette.white.main
        } !IMPORTANT`,
      },
      "& .Mui-voiceOnlyed  .MuiSwitch-track": {
        borderRadius: 16,
        opacity: `${voiceOnly ? 0.8 : 1}!IMPORTANT`,
        backgroundColor: `${
          voiceOnly ? theme.palette.primary.main : theme.palette.white.main
        } !IMPORTANT`,
      },
      "& .MuiButtonBase-root": {
        padding: 0,
      },

      "& .MuiSwitch-thumb": {
        boxShadow: `0px 0px 0px 2px ${theme.palette.black.main}`,
        width: 30,
        height: 30,
        margin: 2,
        position: "absolute",
        top: -2,
        left: -2,
        backgroundPosition: "center",
        backgroundImage: `url(${voice})`,
        backgroundSize: "21px 21px",
        backgroundRepeat: "no-repeat",
        opacity: `${voiceOnly ? 0.8 : 1}!IMPORTANT`,
        zIndex: 12,
      },
    },
  }));

  const handleVoiceOnly = () => {
    dispatch(setVoiceOnly(!voiceOnly));
  };

  return (
    <>
      {voiceOnly && (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            overflow: "hidden",
            display: "flex",
            position: "relative",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          {/* <img
            src={props.data?.author.avatar}
            alt='voice image'
            width='100%'
            height='auto'
            style={{
              marginBottom: "auto",
              marginTop: "auto",
              // height: "370px",
              objectFit: "cover",
              borderRadius: "50%",
            }}
          /> */}
          <CustomAvatar
            src={props.data.author.avatar}
            size={300}
            alt={props.data.author.nickname}
            iconType='voice'
            iconSize={64}
            overlay
          />
          {/* <GraphicEqRoundedIcon
            sx={{
              width: 76,
              height: 76,
              position: "absolute",
              zIndex: 20,
              color: "white.main",
              top: "46%",
              left: "40%",
            }}
          /> */}
          {/* <Box
            width='100%'
            sx={{
              position: "absolute",
              backgroundColor: "black.main",
              opacity: 0.3,
              width: "100%",
              zIndex: 1,
              height: "500px",
            }}
          ></Box> */}
        </Box>
      )}
      <Box sx={{ position: "absolute", top: 70, right: 16, left: 16 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: "12px",
          }}
        >
          <Box
            onClick={() =>
              props.data && navigate(`/profile/${props.data.author.username}`)
            }
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              width: "120%",
            }}
          >
            <Box sx={{ mr: "8px", ml: "2px" }}>
              {!props.data ? (
                <Skeleton variant='circular' width={26} height={26} />
              ) : (
                <CustomAvatar
                  src={props.data.author.avatar}
                  size={45}
                  alt={props.data.author.nickname}
                />
              )}
            </Box>
            {!props.data ? (
              <Skeleton
                width={80}
                height={20}
                sx={{
                  mr: "8px",
                }}
              />
            ) : (
              <Typography
                sx={{
                  fontSize: "16px",
                  lineHeight: "28px",
                  mt: "4px",
                  color: "#2196F3",
                }}
              >
                {props.data.author.nickname}
              </Typography>
            )}
          </Box>
          {props.data?.content_type === "video" && props.data?.extra && (
            <Box
              onChange={handleVoiceOnly}
              sx={{
                direction: "rtl",
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <FormControlLabel
                sx={{
                  "& .MuiTypography-root": {
                    color: "white.main",
                    fontSize: 12,
                    fontWeight: 600,
                    mr: "8px",
                  },
                  "&.MuiFormControlLabel-root": { mr: 0 },
                }}
                control={<VoiceSwitch color='white' checked={voiceOnly} />}
                label='Voice-only'
              />
            </Box>
          )}
        </Box>

        {/* <Replayed color='white' /> */}
        <Box
          sx={{
            direction:
              props.data && RightLeftChecker(props.data.title) ? "rtl" : "ltr",
          }}
        >
          {!props.data ? (
            <Skeleton width={300} height={60} />
          ) : (
            <Typography
              sx={{
                fontFamily: "tahrir",
                fontSize: "27px",
                fontWeight: "600",
                lineHeight: "32px",
                display: "inline-flex",
                backgroundColor: "#00000066",
                color: "white.main",
                mt: "8px",
                padding: "6px 4px 6px 4px",
              }}
            >
              {props.data.title}
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default HeaderMediaPlayer;
